import React from "react";
import { Box, Body2, Display5 } from "@sainsburys-tech/fable";

const body2Style = {
  background: '#f2f2f2',
  color: '#404040',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif'
};

const AlertIdNotFoundMessage = () => (
  <div className="fable:text-center">
    <Display5>Alert ID not found.</Display5>
    <Body2 style={body2Style} className="fable:mt-4">
      We couldn't find that alert ID, please try searching again or use the
      filters to narrow results down.
    </Body2>
  </div>
);

export default AlertIdNotFoundMessage;
